import { ComponentType, PropsWithChildren, Component } from 'react';

import { FormattedMessage } from 'react-intl';

import ButtonGroup from '@atlaskit/button/button-group';
import CustomThemeButton from '@atlaskit/button/custom-theme-button';

import { paginationMessages } from 'src/i18n';
import { publishUiEvent } from 'src/utils/analytics/publish';

import * as styles from './pagination.styled';

export type PrevNextPaginationPropTypes = {
  nextUrl: string | undefined;
  previousUrl: string | undefined;
  onPageChange: () => void;
  component: ComponentType<PropsWithChildren<unknown>>;
  uiEventSource?: string;
  publishEvent: boolean;
};

const buttonClickEventTemplate = {
  action: 'clicked',
  actionSubject: 'button',
};

export default class PrevNextPagination extends Component<PrevNextPaginationPropTypes> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    onPageChange: () => null,
    publishEvent: true,
  };

  handlePrevButtonClick = () => {
    if (this.props.publishEvent) {
      publishUiEvent({
        ...buttonClickEventTemplate,
        source: this.props.uiEventSource || 'prevNextPagination',
        actionSubjectId: 'paginationPrevPageButton',
      });
    }
    this.props.onPageChange();
  };

  handleNextButtonClick = () => {
    if (this.props.publishEvent) {
      publishUiEvent({
        ...buttonClickEventTemplate,
        source: this.props.uiEventSource || 'prevNextPagination',
        actionSubjectId: 'paginationNextPageButton',
      });
    }
    this.props.onPageChange();
  };

  render() {
    const { nextUrl, previousUrl, component } = this.props;

    if (!nextUrl && !previousUrl) {
      return null;
    }

    return (
      <styles.PaginationWrapper>
        <ButtonGroup>
          <CustomThemeButton
            href={this.props.previousUrl}
            isDisabled={!this.props.previousUrl}
            component={this.props.previousUrl ? component : undefined}
            onClick={this.handlePrevButtonClick}
            appearance="link"
          >
            <FormattedMessage {...paginationMessages.previous} />
          </CustomThemeButton>
          <CustomThemeButton
            href={this.props.nextUrl}
            isDisabled={!this.props.nextUrl}
            component={this.props.nextUrl ? component : undefined}
            onClick={this.handleNextButtonClick}
            appearance="link"
          >
            <FormattedMessage {...paginationMessages.next} />
          </CustomThemeButton>
        </ButtonGroup>
      </styles.PaginationWrapper>
    );
  }
}
